import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import getEnvFromLocation from './getEnvFromLocation'
import { keycloak, REALMS } from './keycloakClient'

const authLink = setContext(async ({ headers }: any) => {
  try {
    if (keycloak.authenticated) {
      await keycloak.updateToken(30)
    }

    const accessToken = keycloak.token

    return {
      headers: {
        ...headers,
        ...(accessToken && { authorization: `${accessToken}` }),
        realm: REALMS[getEnvFromLocation()],
      },
    }
  } catch (e) {
    console.error('[authLink error]: error on authLink', e)
  }
})

const httpLink = createHttpLink({
  uri: '/graphql',
})

const links = [authLink, httpLink]

const link = ApolloLink.from(links)

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
})

export default client
